import { lazy } from 'react';

export const WorkingSetPage = lazy(() => import('./workingset/WorkingSetPage.jsx'));
export const WorkingSetsPage = lazy(() => import('./workingsets/WorkingSetsPage.jsx'));
export const WorkingSetsAddPage = lazy(() => import('./workingsets/add/WorkingSetsAddPage.jsx'));
export const UsersAddPage = lazy(() => import('./users/add/UsersAddPage.jsx'));
export const UsersPage = lazy(() => import('./users/UsersPage.jsx'));
export const SourcesAddPage = lazy(() => import('./sources/add/SourcesAddPage.jsx'));
export const SolicitorsAddPage = lazy(() => import('./solicitors/add/SolicitorsAddPage.jsx'));
export const ContactsPage = lazy(() => import('./contacts/ContactsPage.jsx'));
export const LibraryPage = lazy(() => import('./library/LibraryPage.jsx'));
export const ActivityPage = lazy(() => import('./activity/ActivityPage.jsx'));
export const Grants = lazy(() => import('./grants/Grants.jsx'));
export const GrantsSearchPage = lazy(() => import('./grants/search/GrantsSearchPage.jsx'));
export const NoticeEditPage = lazy(() => import('./notice/edit/NoticeEditPage.jsx'));
export const NoticeGrantEditPage = lazy(() => import('./notice/grants/edit/NoticeGrantEditPage.jsx'));
export const NoticePage = lazy(() => import('./notice/NoticePage.jsx'));
export const NoticesPage = lazy(() => import('./notices/NoticesPage'));
export const SolicitorsPage = lazy(() => import('./solicitors/SolicitorsPage.jsx'));
export const SourcesPage = lazy(() => import('./sources/SourcesPage.jsx'));
export const AdminPage = lazy(() => import('./admin/AdminPage.jsx'));
